import { IFormulario } from "@/interfaces/IFormulario";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface FormularioState {
  items: IFormulario[];
  synced: boolean;
}

const initialState: FormularioState = {
  items: [],
  synced: false,
};

const formularioSlice = createSlice({
  name: "FORMULARIO",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: IFormulario[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default formularioSlice.reducer;

export const getFormularioSynced = (state: RootState) => state.formulario.items;
